export type Common = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type LongSize = 'x-small' | 'small' | 'medium' | 'large' | 'x-large';

export const longSizeToCommonSize: Record<LongSize, Common> = {
  'x-small': 'xs',
  'small': 'sm',
  'medium': 'md',
  'large': 'lg',
  'x-large': 'xl',
};
